/* global modForm modUtils */
/**
 * Update all possible location displayed elements on page based on updated zipcde, except for user-location elements inside reviews
 * @param {Object} geoData - The user's geographical data
 */
export function populateLocationFieldsDynamically(geoData) {
	modForm.opts.userLocation = geoData.city + ', ' + geoData.state;
	const userLocation = document.querySelectorAll('.user-location:not(.reviews-block .user-location)');
	if (userLocation.length) {
		userLocation.forEach(function($userLocation) {
			if ($userLocation) {
				$userLocation.innerHTML = modForm.opts.userLocation;
			}
		});
	}

	const cityElements = document.querySelectorAll('.user-city');
	if (cityElements.length && geoData?.city) {
		cityElements.forEach(el => {
			el.textContent = geoData.city;
		});
	}

	const stateElements = document.querySelectorAll('.user-state');
	if (stateElements.length && geoData?.state) {
		stateElements.forEach(el => {
			el.textContent = modUtils.returnStateName(geoData.state);
		});
	}
}
